import React from "react";

/**
 * @component CollapsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CollapsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CollapsIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={6}
      height={9}
      viewBox="0 0 6 9"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CollapsIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M4.243.22L0 4.462l4.243 4.243a.75.75 0 101.06-1.06l-3.18-3.183 3.18-3.182A.75.75 0 004.243.22z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CollapsIcon.displayName = "CollapsIcon";
export default CollapsIcon;
